module.exports = __webpack_public_path__ + "img/bingo-green.905c3f28.png";